import React, { useCallback } from 'react';
import { Icon, Tappable } from '@vectord/components';
import { batch, useDispatch, useSelector } from 'react-redux';

import {
  areAppliedFiltersPresentSelector,
  areCurrentFiltersPresentSelector,
  applyCurrentFilter,
  resetFilters,
  resetSbatGroupBulkUpdate,
  setSbatGroupBulkUpdateFilterModalState,
} from 'features/classCreation';
import styles from './FilterDrawerHeader.module.scss';

function FilterDrawerHeader() {
  const dispatch = useDispatch();
  const areAppliedFiltersPresent = useSelector(
    areAppliedFiltersPresentSelector
  );
  const areCurrentFiltersPresent = useSelector(
    areCurrentFiltersPresentSelector
  );

  const handleModalClose = useCallback(() => {
    dispatch(setSbatGroupBulkUpdateFilterModalState(false));
  }, [dispatch]);

  const handleResetFilter = useCallback(() => {
    batch(() => {
      dispatch(resetFilters());
      dispatch(resetSbatGroupBulkUpdate());
    });
  }, [dispatch]);

  const handleApplyFilter = useCallback(() => {
    batch(() => {
      dispatch(applyCurrentFilter());
      dispatch(resetSbatGroupBulkUpdate());
    });
  }, [dispatch]);

  return (
    <div className={styles.root}>
      <div className="m-r-xs bold h3 dark">
        <Icon
          name="arrow-left"
          className="m-r-xxs cursor"
          onClick={handleModalClose}
        />
        back
      </div>
      <div>
        {areAppliedFiltersPresent && (
          <Tappable
            noHighlight
            onClick={handleResetFilter}
            className="primary m-r-xs h5 bold"
          >
            Reset Filters
          </Tappable>
        )}
        <Tappable
          onClick={handleApplyFilter}
          className="btn btn-primary btn-small btn-long bold"
          disabled={!areCurrentFiltersPresent}
        >
          Apply
        </Tappable>
      </div>
    </div>
  );
}

export default FilterDrawerHeader;
